import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";

export const AppTopbar2 = (props) => {
    const name = localStorage.getItem("user");
    const role = localStorage.getItem("role");
    const history = useHistory();
    const [addressCopied, setAddressCopied] = useState(false);

    const shippingAddress = "1470 Lee Wagener Blvd #101, Fort Lauderdale, FL 33315";

    const handleSignout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("role");
        history.push("/login");
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shippingAddress).then(() => {
            setAddressCopied(true);
            setTimeout(() => setAddressCopied(false), 2000);
        });
    };

    return (
        <>
            <Helmet>
                <link id="theme-link" rel="stylesheet" href="/assets/themes/lara-light-indigo/theme.css" />
            </Helmet>
            <div className="layout-topbar" style={{display:"flex",justifyContent:`${window.innerWidth > 768 ? "space-between" : "center"}`}} >
                {
                    <Link to="/" className="layout-topbar-logo">
                        <img
                            src={
                                props.layoutColorMode === "light" ? "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg" : "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg"
                            }
                            style={{ height: "70px", width: "auto", objectFit: "cover" }}
                            alt="logo"
                        />
                        
                    </Link>
                }

                {/* Desktop Shipping Address - Middle Section */}
                {/* {window.innerWidth > 768 && (
                    <div className="shipping-address-desktop">
                        <div className="address-container" onClick={copyToClipboard} title="Click to copy address">
                            <i className="pi pi-map-marker" style={{ color: "white", marginRight: "8px" }}></i>
                            <span className="address-text">
                                {addressCopied ? "Address Copied!" : `Your US Shipping Address: ${shippingAddress}`}
                            </span>
                            <i className="pi pi-copy" style={{ color: "white", marginLeft: "8px", fontSize: "12px" }}></i>
                        </div>
                    </div>
                )} */}

                {/* <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" style={{color:'white'}} onClick={props.onMobileTopbarMenuClick}>
                    <i className="pi pi-ellipsis-v" />
                </button> */}
                <div className="search_div"></div>

                {/* <ul className={classNames("layout-topbar-menu lg:flex origin-top", { "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive })}>
                    {window.innerWidth < 768 && (
                        <>
                            <div className="dropdwon__header_main">
                                {role === "admin" && (
                                    <Link to="/" className="p-4">
                                        <i className="pi pi-chart-pie" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Dashboard
                                        </span>
                                    </Link>
                                )}

                                <Link to="/packages" className="p-4">
                                    <i className="pi pi-briefcase" />
                                    <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                        Packages
                                    </span>
                                </Link>

                                {role === "admin" && (
                                    <Link to="/packages/ocr" className="p-4">
                                        <i className="pi pi-briefcase" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            OCR Packages
                                        </span>
                                    </Link>
                                )}

                                {role === "admin" && (
                                    <Link to="/customers" className="p-4">
                                        <i className="pi pi-fw pi-user" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Customers
                                        </span>
                                    </Link>
                                )}

                                {role === "admin" && (
                                    <Link to="/labels" className="p-4">
                                        <i className="pi pi-fw pi-tags" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Labels
                                        </span>
                                    </Link>
                                )}

                                {role === "admin" || role==="driver" ? (
                                    <Link to="/deliveries" className="p-4">
                                        <i className="pi pi-fw pi-tags" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Deliveries
                                        </span>
                                    </Link>
                                ):null}

                                {role === "admin" && (
                                    <Link to="/deliveryReport" className="p-4">
                                        <i className="pi pi-fw pi-chart-line" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Delivery Reports
                                        </span>
                                    </Link>
                                )}

                                {role === "admin" && (
                                    <Link to="/scan" className="p-4">
                                        <i className="pi pi-fw pi-stop-circle" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Scan
                                        </span>
                                    </Link>
                                )}

                                {role === "admin" ? (
                                    <Link to="/invoices" className="p-4">
                                        <i className="pi pi-fw pi-wallet" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Invoices
                                        </span>
                                    </Link>
                                ) : (
                                    <Link to="/Userinvoices" className="p-4">
                                        <i className="pi pi-fw pi-wallet" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Invoices
                                        </span>
                                    </Link>
                                )}
                                 {role === "admin" && (
                                    <Link to="/advance" className="p-4">
                                        <i className="pi pi-fw pi-stop-circle" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                            Advance Features
                                        </span>
                                    </Link>
                                )}
                                 {role === "admin" && (
                                    <Link to="/flights" className="p-4">
                                        <i className="pi pi-fw pi-stop-circle" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                           Flights
                                        </span>
                                    </Link>
                                )}
                                 {role === "admin" || role=== "courier" ? (
                                    <Link to="/packages/pending" className="p-4">
                                        <i className="pi pi-fw pi-stop-circle" />
                                        <span className="layout-topbar-item-text" style={{ marginLeft: "10px" }}>
                                          Pending Packages
                                        </span>
                                    </Link>
                                ):null}
                            </div>
                        </>
                    )}
                </ul> */}
                {/* <div className="user_info">
                    <img src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1757928614/4wd_logo_irbmwb.jpg" alt="profile_img" style={{ height: "40px", width: "40px", objectFit: "cover", borderRadius: "50%", border: "1px solid white" }} />
                    <div className="p_div">
                        <p className="p1" style={{color:"white"}}>{name}</p>
                        <p className="p2">{role}</p>
                    </div>
                </div> */}
                {/* <div style={{ marginLeft: "30px", cursor: "pointer" }} onClick={handleSignout}>
                    <i className="pi pi-sign-out" style={{color:"white"}}></i>
                </div> */}
            </div>
            
            {/* Mobile Shipping Address - Below Main Topbar */}
            {/* {window.innerWidth <= 768 && (
                <div className="shipping-address-mobile">
                    <div className="mobile-address-container" onClick={copyToClipboard} title="Click to copy address">
                        <i className="pi pi-map-marker" style={{ color: "white", marginRight: "8px" }}></i>
                        <span className="mobile-address-text">
                            {addressCopied ? "Address Copied!" : `Your US Shipping Address: ${shippingAddress}`}
                        </span>
                        <i className="pi pi-copy" style={{ color: "white", marginLeft: "8px", fontSize: "12px" }}></i>
                    </div>
                </div>
            )} */}
        </>
    );
};